import { createDeepEqualSelector } from '@mb/redux/utils';
import type { Event } from '@mb/types';
import { RootState } from '../store';

export const eventsSelector = (state: RootState): RootState['events'] =>
  state.events;

const getTime = (eventDate: string | null) => {
  const date = eventDate
    ? new Date(Date.parse(eventDate.replace(/-/g, '/')))
    : false;
  return date ? date.getTime() : false;
};

const isFeaturedEvent = (event: Event) => {
  return event.featured !== '0';
};

const isUpcomingEvent = (event: Event) => {
  return getTime(event.start_date);
};

const notEndedEvent = (event: Event) => {
  if (event?.end_date) {
    const currentDate = new Date().getTime();
    const endDate = getTime(event.end_date);
    return endDate && currentDate < endDate;
  }
  return true;
};

export const featuredEventsListSelector = createDeepEqualSelector(
  eventsSelector,
  (events) =>
    events.eventsList?.filter(
      (event) => notEndedEvent(event) && isFeaturedEvent(event),
    ) ?? [],
);

export const upcomingEventsListSelector = createDeepEqualSelector(
  eventsSelector,
  (events) =>
    events.eventsList?.filter(
      (event) => notEndedEvent(event) && isUpcomingEvent(event),
    ) ?? [],
);

export const eventsLoadedSelector = createDeepEqualSelector(
  eventsSelector,
  (events) => events.loaded,
);

export const eventsErrorMessageSelector = createDeepEqualSelector(
  eventsSelector,
  (events) => events.errorMessage,
);
